import Action from "./class.Action";

export default class ClearEverything extends Action {
	constructor(options) {
		super(options);
		this.clear();
	}

	clear() {
		this.mainController.mainView._unsticky();
		this.mainController.mainView.layoutView.$el
			.find(".aops-transporter-bubble")
			.hide();
		this.mainController.mainView.$layoutContainer.css("height", "");
		this.onAdvance(this.$anchor);
	}
}
